import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable()
export class CustomMatSortHeaderIntl{
    changes: Subject<void> = new Subject<void>();
    sortButtonLabel(id: string) { return `${id.split(/(?=[A-Z])/).join(' ')} sorting`;};
}